<div class="main-page consultas">
    <div class="container-fluid">
        <!-- LINHA TITULO + PESQUISA -->

        <div class="row align-items-center">
            <div class="col-12 my-2">
                <h1>
                    <a class="btn btn-voltar text-center mr-2" href="/consultations" data-title="Voltar"><i
                            class="fas fa-arrow-left"></i></a>
                    Consultar item de controle
                </h1>
            </div>
        </div>
        
        <div *ngIf="controlitem.data.length === 0">
            <div class="row no-gutters mt-3">
                <p>Nenhum registro até o momento...</p>
            </div>
            <div class="row no-gutters mt-3">
                <a href="/control-item/create" mat-button color="primary"
                    class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
                    Criar um novo item de controle
                </a>
            </div>
        </div>

        <div class="row no-gutters mt-3" *ngIf="controlitem.data.length > 0">
            <div class="mat-elevation table-content">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field>
                        <mat-label>Campo</mat-label>
                        <select matNativeControl #typeFilter>
                            <option value="nmNome">Nome</option>
                            <option value="cdCodigo">Código</option>
                            <option value="ativo">Ativo</option>
                        </select>
                    </mat-form-field>
                    <mat-form-field fxFlex="40%" class="ml-2">
                        <input autofocus type="text" matInput placeholder="Filtro" #filter />
                    </mat-form-field>
                    <button type="button" mat-icon-button (click)="handleFilter()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div>

                <!-- (matSortChange)="handleSort($event)" -->

                <table mat-table [dataSource]="controlitem" matSort class="mat-elevation-z8">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>

                    <ng-container matColumnDef="nmNome">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Nome
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.nmNome }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="cdCodigo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
                        <td mat-cell *matCellDef="let element">{{ element.cdCodigo }}</td>
                    </ng-container>

                    <ng-container matColumnDef="cdNumeroRegistro">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Número Registro</th>
                        <td mat-cell *matCellDef="let element">{{ element.cdNumeroRegistro }}</td>
                    </ng-container>

                    <ng-container matColumnDef="ativo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Ativo?
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.ativo ? 'SIM' : 'NAO' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="update">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Editar">
                                <a href="/control-item/edit/{{ element.id }}" class="btn btn-link">
                                    <img height="20" src="assets/img/edit.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="handleDelete(element.id)" class="btn btn-link">
                                <img height="20" src="assets/img/trash-cadastro.svg" alt="" />
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <mat-paginator *ngIf="controlitem.data.length !== 0" [pageSize]="pageSize"
                    (page)="handlePageChanged($event)" [length]="totalElements" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>